import _ from 'lodash';

import OrderActions from '../actions/OrderActions';
import { Flow, Stage } from './Flow';
import { PointStages, CheckoutStages, GridPages, JourneyPlannerLayout } from '../constants/AppConstants';


/**
 * Config for the defined stages, could be moved out later to allow different flows
 * for different brands
 */
const STAGES = {
    [ PointStages.SEARCH ]: new Stage({
        next: (current, state) => {
            if (state.search.targetLayout === JourneyPlannerLayout.LIST) {
                return PointStages.CHOOSE_OUTWARD;
            }

            return GridPages.SERVICES;
        }
    }),
    [ GridPages.SERVICES ]: new Stage({
        previous: () => PointStages.SEARCH,
        next (current, { trip, smartcard }) {
            if (!trip.isValid()) {
                return false;
            }
            if (trip.isSmartcard() && smartcard && !smartcard.canLoadProduct()) {
                return false;
            }
            //Skip the delivery page if the smartcard is waiting for a product
            //as it will be delivered with the smartcard
            if (trip.isSmartcard() && smartcard.isAwaitingProduct()) {
                return CheckoutStages.PAYMENT;
            }
            return CheckoutStages.DELIVERY;
        },
        nextAction: (current, state) => {
            const { trip, smartcard } = state;
            if (trip.isSmartcard() && smartcard.isAwaitingProduct()) {
                return OrderActions.createOrderForPreRegisteredSmartcard.bind(OrderActions);
            }
            return OrderActions.createOrUpdate.bind(OrderActions);
        },

        getParams ({ search, trip }) {
            search = trip ? trip.search : search;
            return search.serialize().params;
        },

        getQuery ({ search, trip, promptJourneyDetails, gridVersion = JourneyPlannerLayout.GRID}) {
            search = trip ? trip.search : search;
            search = search.setTargetLayout(gridVersion);
            return _.pickBy({...search.serialize().query, promptJourneyDetails});
        }
    }),
    [ PointStages.CHOOSE_OUTWARD ]: new Stage({
        previous: () => PointStages.SEARCH,
        next (current, { trip, smartcard }) {
            if (!trip.isValid()) {
                return false;
            }
            if (trip.isSmartcard() && smartcard && !smartcard.canLoadProduct()) {
                return false;
            }
            //Skip the delivery page if the smartcard is waiting for a product
            //as it will be delivered with the smartcard
            if (trip.isSmartcard() && smartcard.isAwaitingProduct()) {
                return CheckoutStages.PAYMENT;
            }
            return CheckoutStages.DELIVERY;
        },
        nextAction: (current, state) => {
            const { trip, smartcard } = state;
            if (trip.isSmartcard() && smartcard.isAwaitingProduct()) {
                return OrderActions.createOrderForPreRegisteredSmartcard.bind(OrderActions);
            }
            return OrderActions.createOrUpdate.bind(OrderActions);
        },

        getParams ({ search, trip }) {
            search = trip ? trip.search : search;
            return search.serialize().params;
        },

        getQuery ({ search, trip, promptJourneyDetails }) {
            search = trip ? trip.search : search;
            search = search.setTargetLayout(JourneyPlannerLayout.LIST);
            const step = trip ? trip.listStep : null;
            return _.pickBy(Object.assign({step, promptJourneyDetails}, search.serialize().query));
        }
    }),

    [ CheckoutStages.DELIVERY ]: new Stage({
        previous: () => GridPages.SERVICES
    }),

    [ CheckoutStages.PAYMENT ]: new Stage({
        previous: () => PointStages.SEARCH
    })
};


export default new Flow(STAGES);



// WEBPACK FOOTER //
// ./src/flows/PointFlow.js